export interface TranslationValues {
  GlobalValues: GlobalValues;
  HowToValues: HowToValues;
  LandingValues: LandingValues;
  PhoneValidationValues: PhoneValidationValues;
  CodeValidationValues: CodeValidationValues;
  CompleteValues: CompleteValues;
  IdCaptureValuesFront: IdCaptureValuesSide;
  IdCaptureValuesBack: IdCaptureValuesSide;
  IdCaptureValues: IdCaptureValues;
  SelfieCaptureValues: SelfieCaptureValues;
  AgreementInfoValues: AgreementInfoValues;
  AgreementCheckValues: AgreementCheckValues;
  MobileRedirectValues: MobileRedirectValues;
  CameraErrorValues: CameraErrorValues;
  CitizenshipSelectionValues: CitizenshipSelectionValues;
  IdSelectionValues: IdSelectionValues;
  IdCaptureConfirmValues: IdCaptureConfirmValues;
  RandomActionValues: RandomActionValues;
}

export interface GlobalValues {
  FooterText: string;
  VideoLenght: number;
}

export interface HowToValues {
  IdFaceTitle: string;
  IdFaceSubTitle: string;
  IdBackTitle: string;
  IdBackSubTitle: string;
  IdButton: string;
  TiltTitle: string;
  TiltSubTitle: string;
  TiltButton: string;
  SelfieTitle: string;
  SelfieSubTitle: string;
  SelfieButton: string;
}

export interface LandingValues {
  Title: string;
  Description: string;
  IdInfo: string;
  DeviceInfo: string;
  SmsInfo: string;
  Warning: string;
  WarningMd: string;
  Terms: string;
  Button: string;
  ButtonLeave: string;
}

export interface PhoneValidationValues {
  Title: string;
  Description: string;
  Button: string;
  Label: string;
  SearchCountry?: string;
  FullNumber?: string;
}

export interface CodeValidationValues {
  Title: string;
  Description: string;
  Button: string;
  Error: string;
}

export interface CompleteValues {
  Title: string;
  Description: string;
  Message: string;
}

export interface IdCaptureValuesSide {
  Title: string;
  TitleManualCapture: string;
}

export interface IdCaptureValues {
  Button: string;
  Waiting: string;
  IdDetected: string;
  NoTiltDetected: string;
  Loading: string;
  ErrorTitleR1Blur: string;
  ErrorR1Blur: string;
  ErrorTitleR1: string;
  ErrorR1: string;
  ErrorTitleR2: string;
  ErrorR2: string;
}

export interface SelfieCaptureValues {
  Title: string;
  TitleMore: string;
  FinalTitle: string;
  ErrorTitleR1: string;
  ErrorTitleR2: string;
  ErrorR1: string;
  ErrorR2: string;
  Loading: string;
  FacePoseMapping: string[];
  Waiting: string;
}

export interface AgreementInfoValues {
  Title: string;
  Button: string;
  Terms: string;
  Agreement: string;
}

export interface AgreementCheckValues {
  ButtonYes: string;
  ButtonNo: string;
}

export interface MobileRedirectValues {
  InfoTop: string;
  InfoBottom: string;
  Validation: string;
  InfoWaiting: string;
  InfoAborted: string;
  Send: string;
}

export interface CameraErrorValues {
  Title: string;
  Description: string;
  Info: string;
  InfoTitle: string;
  Button: string;
  HowToLink: string;
}

export interface CitizenshipSelectionValues {
  Title: string;
  Description: string;
  Button: string;
}

export interface IdSelectionValues {
  Title: string;
  Description: string;
  ButtonYes: string;
  ButtonNo: string;
}

export interface IdCaptureConfirmValues {
  Title: string;
  Confirm: string;
  Retry: string;
}

export interface RandomActionValues {
  Title: string;
}
